

















































import { Component, Emit, Model, Ref, Vue, Watch } from 'vue-property-decorator';
import LabelInput from '@/components/form/LabelInput.vue';

@Component({
  components: { LabelInput },
})
export default class ToolImgColorEdit extends Vue {
  @Model('change') public modelData!: { colors: number; brightAdjust: number; saturationAdjust: number; };
  @Ref('form') public formRef!: HTMLFormElement;

  public initFormData = { colors: 6, brightAdjust: 0, saturationAdjust: 0 };
  public formData = { ...this.initFormData };

  // 供父组件使用
  public validate() {
    return this.formRef.validate();
  }

  // 增加颜色数量
  public onDecrementColors() {
    this.formData.colors += 1;
  }

  // 减少颜色数量
  public onIncrementColors() {
    this.formData.colors -= 1;
  }

  // 增加亮度
  public onDecrementBright() {
    this.formData.brightAdjust += 0.1;
  }

  // 减少亮度
  public onIncrementBright() {
    this.formData.brightAdjust -= 0.1;
  }

  // 增加对比度
  public onDecrementSaturation() {
    this.formData.saturationAdjust += 0.1;
  }

  // 减少对比度
  public onIncrementSaturation() {
    this.formData.saturationAdjust -= 0.1;
  }

  @Emit('change')
  @Watch('formData', { deep: true })
  public formDataChange(value: any) {
    return value;
  }

  @Watch('modelData', { deep: true, immediate: true })
  public modelDataChange(value: any) {
    this.formData = value;
  }
}
